import React from 'react'
import { Button, Icon } from '@st-operations/uikit/src/v2'
import { UIKIT_COLORS } from '../../pages/event-feeds/visualization-panel/scale-and-coverage/constants'

import './styles.scss'
import classNames from 'classnames'

const OnboardTooltip = (
  {
    className,
    contentClassName,
    step,
    numberOfSteps,
    left,
    top,
    right,
    arrowDirection = 'left',
    title,
    description,
    onNextClick,
    onClose,
  },
  ref
) => {
  return (
    <div
      ref={ref}
      className={classNames(
        {
          'onboard-tooltip__container onboard-tooltip__container--horizontal':
            arrowDirection === 'left' || arrowDirection === 'right',
          'onboard-tooltip__container onboard-tooltip__container--vertical':
            arrowDirection === 'top' || arrowDirection === 'down',
        },
        className
      )}
      style={{ left, top, right }}
    >
      <If condition={arrowDirection === 'left'}>
        <div className="onboard-tooltip__arrow-left" />
      </If>
      <If condition={arrowDirection === 'top'}>
        <div className="onboard-tooltip__arrow-top" />
      </If>
      <div className={classNames('onboard-tooltip__content', contentClassName)}>
        <div className="onboard-tooltip__content-header">
          <div className="onboard-tooltip__content-header-icon-container">
            <Icon
              className="onboard-tooltip__content-header-icon"
              type="outline"
              icon="idea"
              color={UIKIT_COLORS.ds_green}
            />
          </div>
          <Icon
            className="onboard-tooltip__content-header-icon onboard-tooltip__content-header-icon--clickable"
            type="outline"
            icon="delete"
            width={20}
            height={20}
            onClick={onClose}
          />
        </div>
        <span className="onboard-tooltip__content-title">{title}</span>
        <p className="onboard-tooltip__content-description">{description}</p>
        <div className="onboard-tooltip__content-footer">
          <span className="onboard-tooltip__content-footer-count">
            {step} of {numberOfSteps}
          </span>
          <Button className="onboard-tooltip__content-footer-button" onClick={onNextClick}>
            Next
          </Button>
        </div>
      </div>
      <If condition={arrowDirection === 'right'}>
        <div className="onboard-tooltip__arrow-right" />
      </If>
      <If condition={arrowDirection === 'bottom'}>
        <div className="onboard-tooltip__arrow-bottom" />
      </If>
    </div>
  )
}

export default React.forwardRef(OnboardTooltip)
